import React from "react";
import { Box, IconButton, Typography } from "@mui/material"
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';

const MenuHeader: React.FC<{ restaurantName: string, onIconButtonClick?: () => void }> = (props) => {
    const { restaurantName, onIconButtonClick } = props;
    return <Box
        display={'flex'}
        flexDirection={'row'}
        position={'sticky'}
        alignItems={'center'}
        top={0}
        sx={{
            zIndex: 1,
            px: '8px',
            color: '#8E8EA9',
            background: '#F7F7F7',
            margin: '0 -10px'
        }}
    >
        <Box>
            <LocationOnOutlinedIcon />
        </Box>
        <Box flexGrow={'1'}>
            <Typography variant="h5">{restaurantName}</Typography>
        </Box>
        {onIconButtonClick && <Box >
            <IconButton sx={{ color: '#8E8EA9' }} onClick={onIconButtonClick}>
                <FormatAlignLeftIcon />
            </IconButton>
        </Box>}
    </Box>
}

export default MenuHeader;